import React, { Component, Suspense } from 'react';

//librray
import { ToastContainer } from "react-toastify";
import { connect } from 'react-redux';
import CssBaseline from "@material-ui/core/CssBaseline";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import { Link } from "react-router-dom";
import Hyperlink from "../../Controls/Hyperlink";
import { setGlobalParam } from "../../reducers/reducers";

//component
const _loginLogin = React.lazy(() => import('./_login.login'));
const _forgetLogin = React.lazy(() => import('./_forget.login'));
//const _registerLogin = React.lazy(() => import('./_register.login'));
const _registerLogin = React.lazy(() => import('./index.register'));
const _loginInnerLogin = React.lazy(() => import('./_loginInner.login'));
const _registerInnerLogin = React.lazy(() => import('./_registerInner.login'));

class Login extends Component {

    renderRegister= () => {
        const { dispatch } = this.props;
        dispatch({
          type: setGlobalParam,
          storage: "login.show_register_component",
          response: true,
        }); 
    }

    render() {
        const { switch_class, show_hide_class, show_register_component } = this.props;

        return (
            <div className="login">
                <main>
                    <ToastContainer
                        position="bottom-center"
                        // autoClose={false}
                        newestOnTop
                        closeOnClick
                        autoClose={5000}
                        pauseOnHover
                        rtl={false}
                        pauseOnVisibilityChange
                        draggable
                    />
                    <CssBaseline />
                    <Paper className="login-container">
                        <Suspense fallback={<div>Loading...</div>}>
                            <div className="login-form">
                                <_loginLogin />
                                
                            </div>
                        </Suspense>
                    </Paper>
                </main>
                
                <Typography component="p" className="text-center">
                    Don't have an access yet? {' '} 
                    <Link to={`/register`}>
                        <b>Request now</b>
                    </Link>
                </Typography>
            </div>
        );
    }
}


export default connect(state => ({ ...state.reducer.login }), dispatch => ({ dispatch }))(Login);



// WEBPACK FOOTER //
// ./src/containers/Login/index.login.js